import { FETCHCATS} from '../../actions/types'
const INITIAL_STATE = {
    data: [],
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCHCATS:
            return { ...state, data: action.data }
       default:
            return state;
    }
}